const CartItemsSkeleton = () => (
  <div className="brand-container animate-pulse flex-col">
    <div className="brand-text-xs flex justify-between border-b pb-2 *:bg-base-300">
      <div className="h-4 w-10" />
      <div className="h-4 w-10" />
    </div>
    {[...Array(3)].map((_, index) => (
      <div key={index} className="flex flex-row gap-4 border-t py-4">
        <div className="brand-product-placeholder size-24 bg-base-300" />
        <div className="flex flex-1 flex-col gap-2 *:bg-base-300">
          <div className="h-4 w-1/2" />
          <div className="h-4 w-1/3" />
          <div className="h-4 w-1/4" />
        </div>
        <div className="ml-auto h-4 w-1/6 bg-base-300" />
      </div>
    ))}
  </div>
);

export default CartItemsSkeleton;
